import React, { Component } from 'react';

class MicrolinkCard extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount(){
    }

    render() {
      if (!this.props.preview) return <div className="alert alert-info">Loading Preview...</div>;
      const {preview} = this.props;
      return (
      <React.Fragment>
        <div className="row cursor-pointer" onClick={()=>window.open(preview.url, "_blank")}>
          <div className="col-sm-3">
            <img className="img-fluid" src={preview.img}/>
          </div>
          <div className="col-sm-9">{preview.title}<br/><small>{preview.url}</small></div>
        </div>
      </React.Fragment>);
    }
}

export default MicrolinkCard;



// WEBPACK FOOTER //
// ./src/components/controls/MicrolinkCard.js